import Pagination from '../Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'
import './SolutionsData.css'

const SolutionsData = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesData = [
    {
      id: 1,
      title: 'solutionsData_page.cases.items.delfos.title',
      description: 'solutionsData_page.cases.items.delfos.description',
      icon: '',
      url: 'delfos',
    },
    {
      id: 2,
      title: 'solutionsData_page.cases.items.fretesAnalytics.title',
      description: 'solutionsData_page.cases.items.fretesAnalytics.description',
      icon: '',
      url: 'fretes-analytics',
    },
    {
      id: 3,
      title: 'solutionsData_page.cases.items.kanban.title',
      description: 'solutionsData_page.cases.items.kanban.description',
      icon: '',
      url: 'kanban',
    },
    {
      id: 4,
      title: 'solutionsData_page.cases.items.fretesMachineLearning.title',
      description: 'solutionsData_page.cases.items.fretesMachineLearning.description',
      url: 'fretes-machine-learning',
    },
    {
      id: 5,
      title: 'solutionsData_page.cases.items.fretesInsights.title',
      description: 'solutionsData_page.cases.items.fretesInsights.description',
      icon: '',
      url: 'fretes-insights',
    },
    {
      id: 6,
      title: 'solutionsData_page.cases.items.integraSapIbp.title',
      description: 'solutionsData_page.cases.items.integraSapIbp.description',
      icon: '',
      url: 'integra-SAP-IBP',
    },
    {
      id: 7,
      title: 'solutionsData_page.cases.items.estruturaDadosHorizontal.title',
      description: 'solutionsData_page.cases.items.estruturaDadosHorizontal.description',
      icon: '',
      url: 'estrutura-de-dados-horizontal',
    },
    {
      id: 8,
      title: 'solutionsData_page.cases.items.qualidadeGovernanca.title',
      description: 'solutionsData_page.cases.items.qualidadeGovernanca.description',
      icon: '',
      url: 'qualidade-e-governanca',
    },
    {
      id: 9,
      title: 'solutionsData_page.cases.items.migracaoDatabricks.title',
      description: 'solutionsData_page.cases.items.migracaoDatabricks.description',
      icon: '',
      url: 'migracao-de-dados-databricks',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsData_page.cases.cta')
    const caseTitle = t(caseItem.title)

    trackCtaClick({
      cta_name: 'solutions_related_case_click',
      cta_location: 'solutions_data',
      page_name: 'solutions_data',
      case_title: caseTitle,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container solutions-data">
      <header className="main-container-top">
        <div className="text">
          <h1>{t('solutionsData_page.title')}</h1>
          <p>
            {t('solutionsData_page.description1')} <br />
            {t('solutionsData_page.description2')} <br />
            {t('solutionsData_page.description3')}
          </p>
        </div>

        <div className="image-container">
          <img
            src="/assets/SolutionsPage/phonedata.png"
            alt={t('solutionsData_page.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('solutionsData_page.main.title')}</h2>
          <p>{t('solutionsData_page.main.p1')}</p>
          <p>{t('solutionsData_page.main.p2')}</p>
          <p>{t('solutionsData_page.main.p3')}</p>
          <p>{t('solutionsData_page.main.p4')}</p>
          <p>{t('solutionsData_page.main.p5')}</p>
          <p>{t('solutionsData_page.main.p6')}</p>
        </div>

        <div className="main-content-secondary">
          <hr />
          <h3>{t('solutionsData_page.sections.governance.title')}</h3>
          <p>{t('solutionsData_page.sections.governance.description')}</p>

          <hr />
          <h3>{t('solutionsData_page.sections.support.title')}</h3>
          <p>
            {t('solutionsData_page.sections.support.line1')}
            <br />
            {t('solutionsData_page.sections.support.line2')}
            <br />
            {t('solutionsData_page.sections.support.line3')}
            <br />
            {t('solutionsData_page.sections.support.line4')}
          </p>

          <hr />
          <h3>{t('solutionsData_page.sections.squads.title')}</h3>
          <p>
            {t('solutionsData_page.sections.squads.line1')}
            <br />
            {t('solutionsData_page.sections.squads.line2')}
            <br />
            {t('solutionsData_page.sections.squads.line3')}
            <br />
            {t('solutionsData_page.sections.squads.line4')}
          </p>

          <hr />
          <h3>{t('solutionsData_page.sections.migration.title')}</h3>
          <p>
            {t('solutionsData_page.sections.migration.line1')}
            <br />
            {t('solutionsData_page.sections.migration.line2')}
            <br />
            {t('solutionsData_page.sections.migration.line3')}
            <br />
            {t('solutionsData_page.sections.migration.line4')}
          </p>
        </div>

        <div className="main-content-image">
          <img
            src="/assets/SolutionsPage/databricks (2).png"
            className="DataBricks"
            alt=""
          />
          <img src="/assets/SolutionsPage/azure.png" className="Azure" alt="" />
          <img src="/assets/SolutionsPage/aws (2).png" className="Aws" alt="" />
          <img
            src="/assets/SolutionsPage/google cloud.png"
            className="GoogleCloud"
            alt=""
          />
        </div>
      </div>

      <div className="main-content-extra">
        <h2>{t('solutionsData_page.extra.title')}</h2>
        <p>{t('solutionsData_page.extra.subtitle')}</p>

        <img
          src={t('solutionsData_page.extra.diagramImage')}
          alt={t('solutionsData_page.extra.imageAlt')}
        />
      </div>

      <section className="main-cases-container ai-agent">
        <h2 className="title">{t('solutionsData_page.cases.title')}</h2>
        <p className="subtitle">{t('solutionsData_page.cases.subtitle')}</p>

        <Pagination data={casesData} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span>{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('solutionsData_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default SolutionsData
